import { render, staticRenderFns } from "./distress_status.vue?vue&type=template&id=7fefc164&"
import script from "./distress_status.vue?vue&type=script&lang=js&"
export * from "./distress_status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports